import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a6d0a37c47b2cc96bc344fdd10b9ff874b from "./generated-3d32e7f7-0660-4432-be1c-ba66f273e53c.json";

import aae4a0a8873bb00366d2c232c79fe502fb from "./generated-b12ccad8-a339-460b-8981-26f128109a21.json";

import a9269ce56d4362900b4e6356ff6ae984fb from "./generated-f02b182c-060e-4847-8c59-7278868cf494.json";

import aad51a46b336f1c5f6c80fd19c648258ab from "./generated-4a7fe182-eeca-4a4e-be31-bbf0d306320a.json";

import a11ede0340dab0143ff46383f7c2383ecb from "./generated-1470aff1-5952-4460-9794-565273e9e489.json";

import a8198beb147157324bdd264be7352d960b from "./generated-1ae74c8f-6659-43de-91b8-08ebca9fb028.json";

import ae2b8cd726bd82f9872edc1522f30a95fb from "./generated-92468930-6619-4798-bcb0-7b901268edf6.json";

import a5bc67d43b890cd64cc24e6f9c8a45114b from "./generated-74517db3-fe1a-41c1-9ce0-9ca7a3e98d02.json";

import af6bc5054a13388f4adba6c726a16167eb from "./generated-8d528c1c-60e3-4d68-af34-84ce7c0032d2.json";

import a5f9de46f3f971705ab857f2f5dca2118b from "./generated-2b9bf786-8005-4b4c-b252-9e5685f6209b.json";

import a541fa3df0a47f9556a6bf3059d028cf2b from "./generated-1b0db5b6-339f-41cc-8cba-54729cc28231.json";

import a7db985f266e8d14319b7737045f47a4ab from "./generated-fc6f4b75-feb0-4299-92c2-ac67006fe6e0.json";

import a308f0a70e6fdc87ca32623749721a672b from "./generated-beed5b3c-ed4b-4ef8-90fa-fe5e4bf562c7.json";

import af6f5259db5aa1728a88e6f41c733708bb from "./generated-87bfd776-23ea-4744-b44b-16fdd6d16c0e.json";

import ad74538a7eff05fa1f410a249a6afac74b from "./generated-ff8778ae-7756-453c-a39c-d77a20774d3a.json";

import af60a64dc34bc3c8c7515ca5220790bf5b from "./generated-b156524d-169e-4060-bcd9-53ce997284b9.json";

import a7f1dc5e9d1f226d3b96c75e125cab68fb from "./generated-a35daf78-a58b-43bf-b9eb-32569e771afb.json";

import a5e54c992b12f4aebc9cbd68b610632cdb from "./generated-25043bff-cd0b-4153-a295-bac73691917e.json";

import a4006199849856e7c813af905a1f5732cb from "./generated-8df49172-4662-4966-9c01-567db72fdb4e.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a6d0a37c47b2cc96bc344fdd10b9ff874b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aae4a0a8873bb00366d2c232c79fe502fb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a9269ce56d4362900b4e6356ff6ae984fb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(aad51a46b336f1c5f6c80fd19c648258ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a11ede0340dab0143ff46383f7c2383ecb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a8198beb147157324bdd264be7352d960b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ae2b8cd726bd82f9872edc1522f30a95fb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a5bc67d43b890cd64cc24e6f9c8a45114b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(af6bc5054a13388f4adba6c726a16167eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a5f9de46f3f971705ab857f2f5dca2118b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a541fa3df0a47f9556a6bf3059d028cf2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a7db985f266e8d14319b7737045f47a4ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a308f0a70e6fdc87ca32623749721a672b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(af6f5259db5aa1728a88e6f41c733708bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ad74538a7eff05fa1f410a249a6afac74b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(af60a64dc34bc3c8c7515ca5220790bf5b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a7f1dc5e9d1f226d3b96c75e125cab68fb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a5e54c992b12f4aebc9cbd68b610632cdb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a4006199849856e7c813af905a1f5732cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a7f1dc5e9d1f226d3b96c75e125cab68fb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */